import { requestAPI } from './data/api'
import { updateModel } from './data/Model'
import { selectClientIfNonIsSelected } from './data/interactions'

export default function getMe() {
	updateModel(model => {
		model.me.status.handle = 'loading'
		return model
	})

	return requestAPI('/me', 'GET').then(me => {
		updateModel(model => {
			model.me.data = me
			model.me.status.handle = 'loaded'
			model.me.status.timestamp = new Date()
			model.me.data.clients = model.me.data.hubs
				? model.me.data.hubs.map(client => {
					client.active = false
					return client
				  })
				: []
			return model
		})
		selectClientIfNonIsSelected()
	})
}
